import axios from 'axios';
import AuthService from 'common/auth.service';
import { isEmpty } from 'lodash';
import { API_BASE_URL, isDevMode } from './constants';
import { getCurrentUserData } from './helper';

export const headers = {
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*',
};
const instance = axios.create();

const authService = new AuthService();

instance.interceptors.request.use();
instance.defaults.withCredentials = !isDevMode;

async function fetchResponse(config) {
  const appSource = authService.getAppSourceCookie();
  const { apiKey, apiURL } = await getCurrentUserData(appSource);

  config.url = encodeURI(config.url);

  if (!isEmpty(apiURL) && config.url.startsWith(API_BASE_URL)) {
    config.url = config.url.replace(API_BASE_URL, encodeURI(apiURL));
  }

  if (
    !isEmpty(config.headers['x-api-key']) &&
    config.headers['x-api-key'] === process.env.REACT_APP_HEALTHCARE_API_KEY
  ) {
    config.url = config.url.replace(apiURL, process.env.REACT_APP_HEALTHCARE_API_URL);
  }

  config.headers = {
    'x-api-key': apiKey,
    ...config.headers,
  };

  return instance(config)
    .then((response) => {
      return response?.data;
    })
    .catch(async (error) => {
      console.log('===================== ERROR =====================');

      let refreshAttemptCount = 0;

      const logout = () => {
        authService.unsetSessionCookie();
        authService.unsetRefreshSessionCookie();
        authService.unsetAppSourceCookie();
        window.location.href = '/auth/login';
      };

      if (error?.response?.status === 401 && error?.response?.data?.path?.includes('/user/me') && apiKey) {
        if (refreshAttemptCount >= 2) {
          logout();
          return;
        }

        const token = authService.getRefreshSessionCookie();
        await fetch(`${API_BASE_URL}/user/refresh-token?device=0`, {
          method: 'GET',
          headers: { Authorization: `Bearer ${token}`, 'x-api-key': apiKey },
        })
          .then((res) => res.json())
          .then((response) => {
            if (response?.success === false) {
              logout();
            } else {
              const { accessToken, refreshToken } = response;
              if (accessToken && refreshToken) {
                authService.setSessionCookie(accessToken);
                authService.setRefreshSessionCookie(refreshToken);
                window.location.reload();
              }
            }
          })
          .catch((err) => {
            //--------------- Logout ----------------
            logout();
          });
      }

      // let loadingError = error
      if (!error.response) {
        return { data: {}, success: false, message: 'Check your Internet' };
      }
      const { data, status } = error.response || {};

      // SESSION EXPIRED - SESSION TOKEN EXPIRED
      if (status === 440) {
        logout();
      }

      return data;
    });
}

function getHeaders() {
  if (!isEmpty(authService.getSessionCookie())) {
    headers.Authorization = `Bearer ${authService.getSessionCookie()}`;
  }

  if (!isEmpty(authService.getAnonymousCookie())) {
    headers.Anonymous = authService.getAnonymousCookie();
  } else {
    authService.unsetAnonymousCookie();
  }

  return headers;
}

export const api = (config, header) => fetchResponse({ ...config, headers: { ...getHeaders(), ...header } });

export const get = (url) => {
  return instance.get(url);
};

export const setAxiosCookie = (cookie) => {
  if (cookie !== undefined && cookie !== 'undefined') {
    instance.defaults.headers.cookie = cookie;
  }
};

export const setAxiosLocaleHeader = (code) => {
  if (code !== undefined && code !== 'undefined') {
    instance.defaults.headers.locale = code;
    instance.defaults.headers['accept-language'] = code;
  }
};
